import { displayElementAroundAnchor } from 'utilities/element-position';

const LIST_SPACING = 10;
const VIEWPORT_SPACING = 10;

const OVER_ANCHOR_SIDES = ['bottom', 'top'];
const ABOVE_FIRST_SIDES = ['top', 'bottom'];

function getViewportElement() {

  const element = document.getElementById('startup-main');

  if (element === null) {
    return document.body;
  }

  return element;

}

// A negative vertical spacing pulls the element back onto the anchor, so it covers the "@" instead of sitting under it.
function getOverAnchorSpacing(element, anchorElement) {

  const anchorRectangle = anchorElement.getBoundingClientRect();
  const elementRectangle = element.getBoundingClientRect();

  return -((anchorRectangle.height + elementRectangle.height) / 2);

}

export function positionMentionInput(inputElement, anchorElement) {

  inputElement.style.height = 'auto';

  const spacing = getOverAnchorSpacing(inputElement, anchorElement);

  displayElementAroundAnchor(inputElement, anchorElement, getViewportElement(), spacing, VIEWPORT_SPACING, 'bottom', false, OVER_ANCHOR_SIDES);

}

export function positionMentionList(listElement, anchorElement) {

  listElement.style.height = 'auto';

  displayElementAroundAnchor(listElement, anchorElement, getViewportElement(), LIST_SPACING, VIEWPORT_SPACING, 'top', false, ABOVE_FIRST_SIDES);

}
